import { injectable } from "inversify";
import Download from "./Download";
import { MimeTypes } from "../types";

@injectable()
export default class DownloadPNGFile extends Download {
  getMimeType(): string {
    return MimeTypes.PNG;
  }

  execute(file: Blob, fileName: string): void {
    super.execute(file, fileName);
  }
}
